import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import CustomGrid from '../customgrid/CustomGrid';
import styles from './StaticDataGeneral.module.scss';
import * as actions from './actions';
import * as selectors from './selectors';
import * as appSelectors from '../../app/selectors';
import * as constants from './constants';
import * as appConstants from '../../common/constants';

const StaticDataGeneral = (props) => {
    const { initialise } = props;
    useEffect(() => {
        initialise();
    }, [initialise]);

    const processForCsvExport = (rows) => {
        const mapDataKeys = row => ({ 'Monitoring CSAs': row.csaId, 'Sent To Acadiasoft': row.enabledToSend });
        return rows.map(mapDataKeys);
    };

    const csvFilename = `AcadiasoftMonitoringCSAs_${moment().format(appConstants.dateFormat)}.csv`;

    return (
        <div className={ styles.gridWrapper }>
            <CustomGrid
                columns={ constants.columns }
                pagination
                title="Monitoring CSAs – Upload to Acadiasoft"
                csvFilename={ csvFilename }
                csvMapping={ processForCsvExport }
                rows={ props.rows }
                loading={ props.loading }
                styles={ styles }
                setRowChecked={ props.addToAcadiaSoft }
            />
        </div>
    );
};

StaticDataGeneral.propTypes = {
    rows: PropTypes.arrayOf(PropTypes.shape({})),
    initialise: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    addToAcadiaSoft: PropTypes.func.isRequired
};

StaticDataGeneral.defaultProps = {
    rows: [],
    loading: false
};

const mapStateToProps = state => ({
    rows: selectors.getMonitoringRows(state),
    loading: selectors.getLoadingStatus(state),
    monitorCsaList: appSelectors.getMonitorCsas(state)
});

const mapDispatchToProps = {
    initialise: actions.initialise,
    addToAcadiaSoft: actions.addToAcadiaSoft
};

export default withRouter(connect(mapStateToProps,
    mapDispatchToProps)(StaticDataGeneral));

export { StaticDataGeneral as StaticDataGeneralUnconnected };
